export function resetRedux() {
    return dispatch => {
        dispatch({ type: "RESET"})
    }
}